import { environment } from './../../../../../../environment/environment';
import { CompanyService } from './../../../../../core/services/company/company.service';
import { Component, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EsnEvaluationService } from './../../../../../core/services/esn-evaluation/esn-evaluation.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subject, finalize, forkJoin, takeUntil } from 'rxjs';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {
  serverError,
  successSignature,
} from '../../../../../core/models/messages';
import {
  NgSignaturePadOptions,
  SignaturePadComponent,
} from '@almothafar/angular-signature-pad';
import { ToastrService } from 'ngx-toastr';
import {  ViewChild } from '@angular/core';

import { BsModalRef } from 'ngx-bootstrap/modal';
import * as saveAs from 'file-saver';

const DOMPurify = require('dompurify')
@Component({
  selector: 'app-details-pv',
  templateUrl: './details-pv.component.html',
  styleUrls: ['./details-pv.component.css'],
})
export class DetailsPvComponent {
  signature_consultant: any;
  signature_esn:any;
  safeDescription!: SafeHtml;
  formData = new FormData();
   @ViewChild('signature', { static: false })
   signaturePad!: SignaturePadComponent;
 
   @ViewChild('signatureSection')
    signatureSection!: ElementRef;

  type = [
    { id: 2, name: 'Annuelle' },
    { id: 3, name: 'Semestre' },
    { id: 4, name: 'Trimestre' },
  ];
  dedicated_to = [
    { id: 1, name: 'consultant' },
    { id: 2, name: 'client final' },
  ];
  groupedEvaluationDetails: any[] = [];
  evaluationDetailsArray: any[] = [];
  starsArray: any[] = [];
  evaluationDetais: any;
  idPv: any;
  detailsPv: any;
  evaluation: any;
  evaluationArray!: any[];
  url: string = environment.baseUrl + '/api/Pv/file/signature_files/';
  currentSortDirection: number = 2;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  totalItems!: number;
  startIndex: number = 0;
  endIndex: number = 5;
  listchapitre: any;
 chapitreList: { name: string }[] = [];
  esn_id!: string | null;
  evaluation_id!: string;
  chapitreDetails: any;
  modalRef?: BsModalRef;
  file: any;
  fileError: string = '';
  fileExtention: string = '';
  report : string = '';
  // formPV: FormGroup = this.createPVForm();
  signatureFile: any;
  signatureDataUrl: string | null = null;
  public signaturePadOptions: NgSignaturePadOptions = {
    minWidth: 1,
    canvasWidth: 300,
    canvasHeight: 250,
    backgroundColor: '#ffffff',
  };
  evalDetails: any;
  private unsubscribeAll: Subject<void> = new Subject();

  signatureConsultant : any
  signatureEsn : any

  constructor(
    private evaluationsService: EsnEvaluationService,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    private chapitreservice: CompanyService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private toastrService: ToastrService,
  ) {}

  ngOnInit(): void {
    this.getId();
    forkJoin([this.getId()]).subscribe(() => {
      this.getDetailsPV();
    });

  }

  ngAfterViewInit() {
    this.signaturePad.set('minWidth', 1);
    this.signaturePad.clear();
  }
  
  scrollToSignature() {    
    if (this.signatureSection) {
      this.signatureSection.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  extractTextFromHTML(htmlString: string): string {
    const div = document.createElement('div');
    div.innerHTML = htmlString;
    return div.textContent || div.innerText || '';
  }

  drawComplete() {
    this.signatureDataUrl = this.signaturePad?.toDataURL();
    const blob = this.dataURLToBlob(this.signatureDataUrl);
    this.signatureFile = new File([blob], 'signature.png');
  }
  
  dataURLToBlob(dataURL: string): Blob {
    const arr = dataURL?.match(/:(.*?);/);
    if (arr && arr[1]) {
      const mime = arr[1];
      const bstr = atob(dataURL?.split(',')[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr?.charCodeAt(n);
      }

      return new Blob([u8arr], { type: mime });
    } else {
      return new Blob();
    }
  }
  drawStart(event: MouseEvent | Touch) {
  }
 
  getId(): Observable<void> {
    return new Observable((observer) => {
      this.activatedRoute.paramMap.subscribe({
        next: (params: any) => {
          this.idPv = params.params['id'];
          observer.next();
          observer.complete();
        },
        error: (err) => observer.error(err),
      });
    });
  }

  convertBase64ToFile(base64Data: string, fileName: string): File {
    const arr = base64Data.split(',');
    const mime = arr[0].match(/:(.*?);/)![1]; 
    const bstr = atob(arr[1]); 
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
  
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
  
    return new File([u8arr], fileName, { type: mime });
  }

  getDetailsPV() {
    this.evaluationsService
    .getAllDetailsOfPv(this.idPv)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.evalDetails =  res.data;
          this.signature_esn = this.evalDetails.signature_esn;
          this.signature_consultant = this.evalDetails.signature_consultant;
          this.safeDescription = this.sanitizer.bypassSecurityTrustHtml(this.evalDetails.report)
          this.report =  this.extractTextFromHTML(this.evalDetails.report);
          if(this.evalDetails?.signature_consultant){
            this.getSignatureImage('signature_consultant')
          }
          if(this.evalDetails?.signature_esn){
            this.getSignatureImage('signature_esn')
          }
        },
        error: () => {
        },
      });
  }

  telechagementPV() {
    this.spinner.show();
    const EXTENSION = '.pdf';
    this.evaluationsService.telechagementPV(this.idPv).subscribe({
      next: (res: any) => {
        const blob = new Blob([res], { type: 'application/pdf' });
        let fileName = this.evalDetails.evaluation.name + EXTENSION;
        saveAs(blob, fileName);
        this.spinner.hide();
        this.toastrService.success('PV téléchargé avec succès');
      },
    
      error: () => {
        this.spinner.hide();
        this.toastrService.error('Erreur serveur');
      },
    });
}
  updateDescription(description: string) {
    const sanitizedHtml = DOMPurify.sanitize(description);
    this.safeDescription = this.sanitizer.bypassSecurityTrustHtml(sanitizedHtml);
  }

  getListchapitre(sort?: any) {
    this.spinner.show();
    let dataPayload = !sort
      ? { per_page: this.itemsPerPage, page: this.currentPage }
      : { ...{ per_page: this.itemsPerPage, page: this.currentPage }, ...sort };
    this.chapitreservice
      .getchapitreList(this.idPv, dataPayload)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.listchapitre = res.data.items.data;
          this.totalItems = res.data.items.total;
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  exportToPDF() {
    const element = document.getElementById('kt_app_content_container');

    if (element) {
      this.spinner.show();
      html2canvas(element).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save('export_Pv.pdf');
        this.spinner.hide();
      });
    }
  }

  print() {
    const contenuImprimable = document.getElementById(
      'kt_app_content_container'
    );

    if (contenuImprimable) {
      window.print();
    }
  }
  addSigned(id: any) {
    this.router.navigate(['/evaluation/ajout-question', { id: id }]);
  }

  clearSignature(){
    this.signaturePad?.clear()
    this.signatureFile = null
  }

  sendSignature() {
      this.spinner.show();
      if (!this.signatureFile) {
        this.spinner.hide();
        return;
      }
  
      let formData = new FormData();
      formData.append('signature_file', this.signatureFile);

      this.evaluationsService.addSignature(this.idPv, formData).subscribe(
        (response) => {
          this.toastrService.success(successSignature);
          this.getDetailsPV()
          this.spinner.hide();
        },
        (error) => {
          this.spinner.hide();
          this.toastrService.error(serverError);
        }
      );
    }

  navigatePVList(){
      this.router.navigateByUrl( `/evaluation/pv`);
  }

  getSignatureImage(type : string){
    this.evaluationsService
      .getSignatureImage(this.idPv, type).subscribe(blob => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          let image = this.sanitizer.bypassSecurityTrustUrl(reader.result as string);
          if(type === 'signature_consultant'){
            this.signatureConsultant = image
          }else{
            this.signatureEsn = image
          }
        };
      });
  }
}
